import { Box, Flex, Heading, Text, VStack } from '@chakra-ui/react';

export const PointsSummaryCard = ({ totalPoints, tier }) => {
    // Calculate progress to next tier
    const progressPercent = Math.min(100, Math.round((totalPoints / tier.nextTierPoints) * 100));

    return (
        <Box bg='linear-gradient(135deg, #F43F5E 0%, #FB7185 100%)' borderRadius='2xl' p={{ base: 6, md: 8 }} color='white' boxShadow='xl' position='relative' overflow='hidden'>
            {/* Decorative background circle */}
            <Box position='absolute' top='-20px' right='-20px' w='150px' h='150px' borderRadius='full' bg='whiteAlpha.200' />

            <Flex justify='space-between' align='flex-start' direction={{ base: 'column', md: 'row' }} gap={4} position='relative' zIndex={1}>
                <VStack align='flex-start' spacing={1}>
                    <Text fontSize={{ base: 'sm', md: 'md' }} fontWeight='medium' opacity={0.9}>
                        Total Points
                    </Text>
                    <Heading size={{ base: '2xl', md: '3xl' }} fontWeight='black' letterSpacing='tight'>
                        {totalPoints.toLocaleString('id-ID')}
                    </Heading>
                </VStack>
                {/* 
                <VStack align={{ base: 'flex-start', md: 'flex-end' }} spacing={2} minW={{ md: '250px' }}>
                    <Flex align='center' bg='whiteAlpha.300' px={4} py={2} borderRadius='full'>
                        <Icon as={FiStar} mr={2} color='yellow.300' />
                        <Text fontWeight='bold' fontSize='sm'>
                            {tier.name}
                        </Text>
                    </Flex>
                    <Box w='full' mt={2}>
                        <Flex justify='space-between' mb={1} fontSize='xs' opacity={0.9}>
                            <Text>Progress</Text>
                            <Text>
                                {totalPoints.toLocaleString('id-ID')} / {tier.nextTierPoints.toLocaleString('id-ID')}
                            </Text>
                        </Flex>
                        <Progress value={progressPercent} size='sm' colorScheme='yellow' bg='whiteAlpha.300' borderRadius='full' />
                        <Text fontSize='xs' textAlign='right' mt={1} opacity={0.8}>
                            {tier.nextTierPoints - totalPoints} pts to {tier.nextTierName}
                        </Text>
                    </Box>
                </VStack> */}
            </Flex>
        </Box>
    );
};
